












































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { faEllipsisH, faQuestionCircle } from '@fortawesome/pro-regular-svg-icons';
import { Resolve } from 'vue-di';
import { Title } from '~/decorators/Title';
import SessionModule from '~/store/session';
import styles from '~/assets/style/variables.scss';
import { clearRecords } from '~/services/clearRecords';
import EnrollmentModule from '~/store/enrollment';

@Component<Index>({
    layout: 'default',
    created() {
        this.enrollment.clear();
    },
})
@Title(process.env.NAME!)
export default class Index extends Vue {
    @Resolve
    public enrollment!: EnrollmentModule;
}
